import * as tslib_1 from "tslib";
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { trace } from 'owa-trace';
import { ANCHOR_TAG_NAME } from './processAnchorElements';
import processAnchorElements, { AnchorElementsSource } from './processAnchorElements';
export default function handleBeforePasteEvent(event, attachmentPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var links;
        return tslib_1.__generator(this, function (_a) {
            if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove') ||
                event.pasteOption !== 0 /* PasteHtml */) {
                return [2 /*return*/];
            }
            trace.info('handleBeforePasteEvent');
            links = event.fragment.querySelectorAll(ANCHOR_TAG_NAME);
            processAnchorElements(links, null, AnchorElementsSource.PasteHtml, attachmentPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds);
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=handleBeforePasteEvent.js.map